import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Drawer as AntDrawer } from 'antd';
import { setLightness } from 'polished';
import { identity } from 'lodash-es';
var Drawer = styled(AntDrawer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-drawer-body {\n    background-color: ", ";\n    height: fit-content;\n    padding: ", ";\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  ", "\n"])), function (props) {
  return setLightness(0.95, props.theme.colors.primary);
}, function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      .ant-drawer-body {\n        padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n      }\n    } \n  ");
});

var BannerDrawer = function BannerDrawer(_ref) {
  var children = _ref.children,
      dataTestId = _ref['data-testid'],
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 256 : _ref$height,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? identity : _ref$onClose;
  useEffect(function () {
    document.getElementById('root').style.paddingBottom = visible ? "".concat(height, "px") : '0';
  }, [visible, height]);
  return /*#__PURE__*/React.createElement(Drawer, {
    closable: false,
    "data-testid": dataTestId,
    height: height,
    mask: false,
    onClose: onClose,
    placement: "bottom",
    visible: visible
  }, children);
};

export default BannerDrawer;